// カートページのUI制御・フォーム管理を担う。
// カートアイテムの数量変更・削除は cart.js が担当する。
//
// このファイルの主な責務:
// - Liquid が出力した window.CART_DATA をもとに、ページロード直後のカート自動修正をまとめて実行する
// - checkout ボタンの活性/非活性を、配送温度帯・アイス同意・配送日時・eギフト入力状態から判定する
// - カートページ固有の UI（配送日、eギフト、ギフトバッグ、周年eチケット）を初期化する
//
// 外部依存（cart.liquid のscript読み込み順で、すべてこのファイルより先に読み込まれる）:
// - window.CART_DATA: sections/cart.liquid が出力するカート状態
// - window.CartAPI: assets/cart.js が公開する Shopify Ajax API ラッパー
// - window.cartUpdateAndReload: assets/cart.js が公開する更新後リロード関数
// - window.getGiftBagData: assets/cart.js から呼ばれるため、このファイルで互換APIとして公開する
// - dateToStr12H: assets/e-gift.js が公開する日付フォーマッタ
// - jQuery / jQuery UI datepicker / Slick

$(function () {
  // CART_DATA は Liquid 由来なので、JS 側では常に欠損に耐える形で読む。
  const cartData = window.CART_DATA || {};
  const hasShippingConflict = !!(cartData.hasFrozenOnly && cartData.hasNormalOnly);
  const countIce = Number(cartData.countIce) || 0;
  const hasNormalOnly = !!cartData.hasNormalOnly;
  const $checkoutButton = $('[name="checkout"]');
  // Liquid 側ですでに disabled なケース（販売停止・購入制限など）は JS で勝手に解除しない。
  const isStaticCheckoutDisabled = $checkoutButton.prop("disabled");
  // checkoutIntent は「ユーザー操作として checkout 可能な状態を目指しているか」を保持する。
  // 実際に押せるかどうかは getCheckoutState() で毎回再判定する。
  let checkoutIntent = $checkoutButton.length > 0 && !$checkoutButton.hasClass("disable");

  try {
    localStorage.removeItem("cartBack_lastVisit");
  } catch (error) {
    // localStorage が無効な環境ではカート制御を継続する。
    console.error("Failed to remove cartBack_lastVisit from localStorage:", error);
  }

  // Shopify Ajax API へのアクセスは cart.js の CartAPI に集約する（実装を二重に持たない）。
  const CartAPI = window.CartAPI;

  // Liquid からは key/id のリストがカンマ区切り文字列で来るため、JS で扱いやすい配列に正規化する。
  const compactTargets = (targets) => {
    if (Array.isArray(targets)) {
      return targets.map((target) => String(target).trim()).filter(Boolean);
    }

    return String(targets || "")
      .split(",")
      .map((target) => target.trim())
      .filter(Boolean);
  };

  // /cart/update.js に渡す updates は line item key または variant id をキーにする。
  // 空値や "0" を除外し、無効な対象が混ざっても更新リクエストを壊さないようにする。
  const addCartUpdate = (updates, target, quantity) => {
    const normalizedTarget = String(target || "").trim();
    if (!normalizedTarget || normalizedTarget === "0") {
      return false;
    }

    updates[normalizedTarget] = quantity;
    return true;
  };

  // cart.js の既存リロード戦略（cartUpdateAndReload）でページを再同期する。
  const reloadCart = (cart) => {
    const productTypes = cart && Array.isArray(cart.items)
      ? cart.items.map((item) => item.product_type)
      : [];

    window.cartUpdateAndReload(productTypes);
  };

  // ページロード直後に必要なカート補正を1つの updates にまとめる。
  // 複数条件が同時に成立しても Ajax と reload を1回に抑えるための中心処理。
  const buildInitialCartUpdates = (data) => {
    const result = {
      updates: {},
      messages: [],
      redirectUrl: "",
    };

    // 未ログインの会員限定商品は、削除よりログイン導線を優先する。
    // 既存挙動を維持するため、ここでは cart update を作らず redirect を返す。
    if (data.isLimitStatusProduct && !data.isCustomer) {
      result.messages.push("会員ステータス限定販売商品がカートに入っています。\nログインしてください。");
      result.redirectUrl = "/account/login?return_url=/cart";
      return result;
    }

    if (data.isRemoveCampaignEticket) {
      if (addCartUpdate(result.updates, data.campaignEticketItemKey, 0)) {
        result.messages.push("合計金額が7,000円未満のため、eチケットを解除します。\n合計7,000円以上の商品をカート投入後、eチケットを選択ください。");
      }
    }

    if (data.isLimitStatusProduct && data.isCustomer && data.isStatusNotMatch) {
      if (addCartUpdate(result.updates, data.limitStatusItemKey, 0)) {
        result.messages.push("会員ステータス条件の満たしていない商品がカートに入っています。\n会員ステータスを確認後、再度カートに投入してください。");
      }
    }

    // 温度帯未設定の商品と、それに紐づくラッピングをまとめて削除対象にする。
    if (data.hasInvalidItems) {
      const invalidTargets = compactTargets(data.invalidItemKeys);

      invalidTargets.forEach((target) => {
        addCartUpdate(result.updates, target, 0);
      });

      if (invalidTargets.length > 0) {
        result.messages.push("お届け方法の不明な商品がカートに入っています。\n該当商品をカートから削除します。");
      }
    }

    // アイス本体 nc0042 と配送資材 s078 の数量差を、カート更新として補正する。
    // 資材がまだカートに無い場合は line item key が存在しないため、variant id で追加する。
    if (Number(data.diffIceBox) !== 0) {
      const target = data.iceBoxItemKey || data.iceBoxVariantId;
      const message = Number(data.diffIceBox) > 0
        ? "配送用の資材を追加します"
        : "配送用資材の数を調整します";

      if (addCartUpdate(result.updates, target, Number(data.countIce) || 0)) {
        result.messages.push(message);
      }
    }

    return result;
  };

  // 初期自動修正を実行する。
  // true を返した場合は reload/redirect が発生するため、以降のUI初期化は行わない。
  const runInitialCartCorrections = async () => {
    const correction = buildInitialCartUpdates(cartData);

    if (correction.redirectUrl) {
      alert(correction.messages.join("\n\n"));
      window.location.href = correction.redirectUrl;
      return true;
    }

    if (Object.keys(correction.updates).length === 0) {
      return false;
    }

    try {
      const cart = await CartAPI.updateCart(correction.updates);
      if (correction.messages.length > 0) {
        alert(correction.messages.join("\n\n"));
      }
      reloadCart(cart);
    } catch (error) {
      // 通信失敗時にリロードすると、補正条件が残ったまま alert とリロードを無限に繰り返すため、
      // ここではリロードせず通常のUI初期化に進める。補正は次回のページロードで再試行される。
      console.error("Initial cart correction failed:", error);
      alert("通信に失敗したため、カート内容の自動調整を実行できませんでした。\n時間をおいてページを再読み込みしてください。");
      return false;
    }

    return true;
  };

  // checkout ボタンの状態計算だけを担う純粋寄りの関数。
  // DOM反映は applyCheckoutState() に分け、イベントごとの分岐を増やさない。
  const getCheckoutState = (isCheckout) => {
    if (!$checkoutButton.length) {
      return { canCheckout: false, hardDisabled: false };
    }

    // Liquid 側で不可にした状態、または冷凍/常温混在は JS で解除しない。
    if (isStaticCheckoutDisabled || hasShippingConflict) {
      return { canCheckout: false, hardDisabled: true };
    }

    // アイス注文は同意チェックと配送指定が必須。eギフト時は From/Dear の入力も必須にする。
    if (countIce > 0) {
      const isAgree = $("#agree_ice_checkbox").prop("checked");
      if (!isAgree) {
        return { canCheckout: false, hardDisabled: false };
      }

      if ($("#form__with-egift").prop("checked")) {
        const egiftFromName = $('[name="attributes[egift-fromname]"]').val();
        const egiftDearName = $('[name="attributes[egift-dearname]"]').val();
        return {
          canCheckout: !!(isCheckout && egiftFromName !== "" && egiftDearName !== ""),
          hardDisabled: false,
        };
      }

      return {
        canCheckout: $("#delivery_time").val() !== "" && $("#delivery_date").val() !== "",
        hardDisabled: false,
      };
    }

    return { canCheckout: !!isCheckout, hardDisabled: false };
  };

  // checkout 状態を DOM に反映する。
  // hardDisabled は Liquid 由来の制約を保持するため disabled 属性も付ける。
  const applyCheckoutState = (state) => {
    if (!$checkoutButton.length) {
      return;
    }

    if (state.canCheckout) {
      $checkoutButton.removeClass("disable");
      $checkoutButton.prop("disabled", false);
      return;
    }

    $checkoutButton.addClass("disable");
    if (state.hardDisabled) {
      $checkoutButton.prop("disabled", true);
    }
  };

  // イベントハンドラから呼ぶ唯一の checkout 更新入口。
  // 「意図」を更新した上で、現在のDOM状態から押下可否を再評価する。
  const refreshCheckoutButton = (nextCheckoutIntent) => {
    if (typeof nextCheckoutIntent === "boolean") {
      checkoutIntent = nextCheckoutIntent;
    }

    applyCheckoutState(getCheckoutState(checkoutIntent));
  };

  // アイス商品の注意事項同意と、配送指定エリアの初期表示を制御する。
  const initIceControls = () => {
    $("#agree_ice_checkbox").on("change", function () {
      refreshCheckoutButton($(this).prop("checked"));
    });

    if (hasShippingConflict) {
      refreshCheckoutButton(false);
    }

    if (countIce > 0) {
      $checkoutButton.on("click", function () {
        $("#iceBoxModal").addClass("is-show");
      });
      $("#iceBoxModal .back").on("click", function () {
        $("#iceBoxModal").removeClass("is-show");
      });
      $(".order-delivery").show();
    } else {
      $(".order-delivery").hide();
    }
  };

  // 通常配送の配送日/配送時間入力を初期化する。
  // datepicker が読み込まれていない場合でも、他のカート機能は動かす。
  const initDeliveryDatePicker = () => {
    const $datepicker = $("#datepicker");
    if (!$datepicker.length) {
      return;
    }

    $datepicker.on("load change", function () {
      $(".ui-state-active").removeClass("ui-state-active");
    });

    $("[name='fix-date']").on("click", function () {
      const fixDateValue = $(this).val();
      if (fixDateValue === "none-fix-date") {
        $(".order-delivery").hide();
        $(".ui-state-active").removeClass("ui-state-active");
        $("#delivery_date").val("");
        $("#delivery_youbi").val("");
        $("#delivery_time").val("");
        refreshCheckoutButton(true);
      } else if (fixDateValue === "fix-date") {
        $("#delivery_time").val($("#tmp_delivery_time").val());
        $(".order-delivery").show();
        refreshCheckoutButton(false);
      }
    });

    $("[name='delivery_time']").on("change", function () {
      const fixTimeValue = $(this).val();
      $("#delivery_time").val(fixTimeValue);
      $("#tmp_delivery_time").val(fixTimeValue);
      refreshCheckoutButton($("#delivery_time").val() !== "" && $("#delivery_date").val() !== "");
    });

    if (typeof $.fn.datepicker !== "function") {
      return;
    }

    // 注文属性「曜日」はメールテンプレート側の置換に合わせて英語曜日で保存する。
    const weekStr = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const now = new Date();
    // 季節施策期間は配送可能日の上限を延長する。恒久化する場合は section setting 化候補。
    const limitDtStart = new Date("2026/01/17");
    const limitDtEnd = new Date("2026/02/10");
    const limitDtStart2 = new Date("2026/02/19");
    const limitDtEnd2 = new Date("2026/03/14");
    const minDate = new Date(now.getTime());
    let maxDate = new Date(now.getTime());

    minDate.setDate(minDate.getDate() + 4);
    maxDate.setDate(maxDate.getDate() + 30);

    if (now.getTime() >= limitDtStart.getTime() && now.getTime() < limitDtEnd.getTime()) {
      const limitMaxDate = new Date("2026/02/14");
      if (maxDate.getTime() < limitMaxDate.getTime()) {
        maxDate = limitMaxDate;
      }
    }

    if (now.getTime() >= limitDtStart2.getTime() && now.getTime() < limitDtEnd2.getTime()) {
      const limitMaxDate = new Date("2026/03/14");
      if (maxDate.getTime() < limitMaxDate.getTime()) {
        maxDate = limitMaxDate;
      }
    }

    const dateFormat = "yy/mm/dd";
    const disableDates = [];

    $datepicker.datepicker({
      minDate,
      maxDate,
      dateFormat,
      defaultDate: null,
      onSelect(dateText) {
        $("#delivery_date").val(dateText);
        $("#tmp_delivery_date").val(dateText);

        const selectedDate = new Date(dateText);
        $("#delivery_youbi").val(weekStr[selectedDate.getDay()]);
        $("#tmp_delivery_youbi").val(weekStr[selectedDate.getDay()]);
        refreshCheckoutButton($("#delivery_time").val() !== "" && $("#delivery_date").val() !== "");
      },
      beforeShowDay(date) {
        const currentDate = new Date();
        const checkDate = new Date();
        const currentDay = currentDate.getDay();

        checkDate.setDate(currentDate.getDate() + 7);
        if (date.getTime() < checkDate.getTime()) {
          if (currentDay === 5 && (date.getDay() === 1 || date.getDay() === 2 || date.getDay() === 3)) {
            return [false, "ui-state-disabled"];
          }

          if (currentDay === 4 && hasNormalOnly && (date.getDay() === 1 || date.getDay() === 2)) {
            return [false, "ui-state-disabled"];
          }

          if (currentDay === 6 && (date.getDay() === 2 || date.getDay() === 3)) {
            return [false, "ui-state-disabled"];
          }
        }

        const disableDate = $.datepicker.formatDate(dateFormat, date);
        return [disableDates.indexOf(disableDate) === -1, "", ""];
      },
    });

    $datepicker.addClass("notranslate");
  };

  // eギフト受け取り期限を「購入日から14日後」として表示する。
  // 日付フォーマットは e-gift.js の dateToStr12H に集約する。
  const initEgiftLimitDate = () => {
    if (!$("#limited_date").length) {
      return;
    }

    const limitDate = new Date();
    limitDate.setDate(limitDate.getDate() + 14);
    $("#limited_date").text(dateToStr12H(limitDate, "Y年M月D日（W）"));
  };

  // eギフトカードデザインの Slick スライダーを初期化し、選択中カードIDを hidden input に同期する。
  const initEgiftSlider = () => {
    const $slide = $(".slide");
    if (!$slide.length || typeof $.fn.slick !== "function") {
      return;
    }

    $slide.on("init", function () {
      const activeSlide = $(this).find(".slick-active");
      $("#card-label").text(activeSlide.attr("data-label"));
    });

    const mainSlick = $slide.slick({
      variableWidth: true,
      centerPadding: "0",
      slidesToShow: 1,
      infinite: true,
      centerMode: true,
      autoplay: false,
      arrows: true,
      prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0036/3721/5277/files/arrow-left.png?v=1638237387" class="slide-arrow prev-arrow">',
      nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0036/3721/5277/files/arrow-right.png?v=1638237387" class="slide-arrow next-arrow">',
    });

    mainSlick.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      mainSlick.find(".slick-slide").each((index, el) => {
        const $this = $(el);
        const slickIndex = $this.attr("data-slick-index");
        if (nextSlide === slick.slideCount - 1 && currentSlide === 0) {
          $this.toggleClass("is-active-next", slickIndex === "-1");
        } else if (nextSlide === 0) {
          $this.toggleClass("is-active-next", slickIndex == slick.slideCount);
        } else {
          $this.removeClass("is-active-next");
        }
      });
    });

    mainSlick.on("afterChange", function () {
      const activeSlide = $(this).find(".slick-active");
      $("#card-label").text(activeSlide.attr("data-label"));
      $("#card-id").val(activeSlide.attr("data-id"));
    });
  };

  // ギフトバッグ商品の DOM 表現を、cart.js から扱いやすい配列に変換する。
  // 新しい data 属性を優先し、旧クラス/属性も fallback として読む。
  const getGiftBagItems = () => {
    return Array.from(document.querySelectorAll("[data-cart-gift-bag], .gift_bag_option_wrapper"))
      .map((wrapper) => {
        const quantityWrapper = wrapper.querySelector("[data-cart-gift-bag-quantity], .gift_bag_otion_quantity");
        const quantityInput = wrapper.querySelector(".gift_bag_otion_cart_num");
        const id = wrapper.dataset.variantId
          || wrapper.dataset.id
          || (quantityWrapper && quantityWrapper.getAttribute("variant-id"));

        return {
          id,
          quantity: parseInt(quantityInput && quantityInput.value, 10) || 0,
        };
      })
      .filter((item) => item.id);
  };

  // cart.js の removeAll から呼ばれる互換API。
  // removeAll で消える表示行を除いた結果、ギフトバッグ数が通常商品数を上回る場合はS/M両方を削除する
  //（ギフトバッグは通常商品より多くならないようにする）。
  window.getGiftBagData = function (removedCartItemKeys) {
    const giftBagItems = getGiftBagItems();
    const activeGiftBagItems = giftBagItems.filter((item) => item.quantity > 0);
    const totalBagQuantity = activeGiftBagItems.reduce((sum, item) => sum + item.quantity, 0);
    const removedKeys = new Set(compactTargets(removedCartItemKeys));
    // ラッピング行も .js-cart-product として描画されるため、通常商品のカウントから除外する。
    const wrappingKeys = new Set(
      Array.from(document.querySelectorAll("[data-cart-item-wrapping-keys]"))
        .flatMap((item) => compactTargets(item.dataset.cartItemWrappingKeys))
    );
    const remainingProductCount = Array.from(document.querySelectorAll(".js-cart-product"))
      .filter((item) => !removedKeys.has(item.dataset.cartItemKey) && !wrappingKeys.has(item.dataset.cartItemKey))
      .length;

    return {
      id: activeGiftBagItems[0] ? activeGiftBagItems[0].id : null,
      ids: activeGiftBagItems.map((item) => item.id),
      count: totalBagQuantity,
      shouldRemove: totalBagQuantity > 0 && removedKeys.size > 0 && remainingProductCount < totalBagQuantity,
    };
  };

  // 「オプションを追加しない」を選んだ時に、ギフトバッグS/Mをまとめて削除する。
  const initGiftBagOptions = () => {
    $(".form__option input:radio").on("change", async function () {
      const selectBagId = $(this).attr("id");
      const giftBagIds = getGiftBagItems().map((item) => item.id);

      if (selectBagId === "form__none-option") {
        const updates = {};
        giftBagIds.forEach((id) => {
          updates[id] = 0;
        });

        if (Object.keys(updates).length === 0) {
          return;
        }

        try {
          const cart = await CartAPI.updateCart(updates);
          reloadCart(cart);
        } catch (error) {
          console.error("Gift bag update failed:", error);
          window.location.reload();
        }
      } else {
        $(".btn_cart").addClass("disable");
        $(".gift_bag_option_wrapper").show();
      }
    });
  };

  // 配送伝票用の送り主名入力を制御する。
  const initSenderName = () => {
    $('[name="cart_options[fromname]"]:radio').on("change", function () {
      if ($("#form__none-fromname").prop("checked")) {
        $('[name="attributes[from-name]"]').val("");
        $(".form__with-fromname").hide();
      } else {
        $(".form__with-fromname").show();
      }
    });

    $('[name="attributes[from-name]"]').on("load keyup", function () {
      const text = $('[name="attributes[from-name]"]').val();
      if (text && text.length > 10) {
        $('[name="attributes[from-name]"]').val(text.slice(0, 10));
      }
    });
  };

  // Slick 上で現在選択されているeギフトカードIDを取得する。
  const getActiveEgiftCardId = () => {
    return $(".slide").find(".slick-active").attr("data-id") || "";
  };

  // 通常配送に戻した時、eギフト専用の注文属性が checkout に残らないように消す。
  const resetEgiftAttributes = () => {
    $('[name="attributes[egift-fromname]"]').val("");
    $('[name="attributes[egift-dearname]"]').val("");
    $('[name="attributes[egift-message]"]').val("");
    $('[name="attributes[egift-card-id]"]').val("");
    $('[name="attributes[egift-receive]"]').val("");
  };

  // 通常配送/eギフトの切り替えと、eギフト入力に応じた checkout 制御を担当する。
  const initEgiftForm = () => {
    $(".form__e-gift-option-wrapper").hide();

    $('[name="attributes[egift]"]:radio').on("change", function () {
      if ($("#form__none-egift").prop("checked")) {
        $(".form__e-gift-option-wrapper").hide();
        $(".form__fix-date-wrapper").show();

        if ($("#form__none-fix-date").prop("checked")) {
          refreshCheckoutButton(true);
        } else {
          $("#delivery_date").val($("#tmp_delivery_date").val());
          $("#delivery_time").val($("#tmp_delivery_time").val());
          $("#delivery_youbi").val($("#tmp_delivery_youbi").val());
          refreshCheckoutButton($("#delivery_time").val() !== "" && $("#delivery_date").val() !== "");
        }

        resetEgiftAttributes();
        return;
      }

      if ($("#form__with-egift").prop("checked")) {
        $(".uiDeliveryDateVal,.uiDeliveryDayVal,.uiDeliveryTimeVal").removeAttr("value");
        $("#delivery_date").val("");
        $("#delivery_youbi").val("");
        $("#delivery_time").val("");

        $("#egift-param").html(`
          <input type="hidden" id="card-id" name="attributes[egift-card-id]" value="">
          <input type="hidden" name="attributes[egift-receive]" value="yet">
        `);
        $("#card-id").val(getActiveEgiftCardId());

        $(".form__fix-date-wrapper").hide();
        $(".form__e-gift-option-wrapper").show();
        refreshCheckoutButton($('[name="attributes[egift-fromname]"]').val() !== "");

        if (typeof $.fn.slick === "function" && $(".slide").length) {
          $(".slide").slick("setPosition");
        }
      }
    });

    $('[name="attributes[egift-fromname]"], [name="attributes[egift-dearname]"]').on("keyup", function () {
      const maxLength = 20;
      const value = $(this).val();
      if (value && value.length >= maxLength) {
        $(this).val(value.slice(0, maxLength));
      }

      const hasFromName = $('[name="attributes[egift-fromname]"]').val() !== "";
      refreshCheckoutButton(hasFromName);
      $(".e-gift-fromname-blank").toggle(!hasFromName);
      $('[name="attributes[egift-fromname]"]').toggleClass("error", !hasFromName);
    });
  };

  // 周年eチケットは、参照商品と専用ケーキを properties でペアにして同時追加/削除する。
  const initAnniversaryEticket = () => {
    if (cartData.anniversaryCakeVariantId) {
      $(".js-anniversary-eticket-add").on("click", async function (event) {
        event.preventDefault();
        const btn = $(this);
        btn.css("pointer-events", "none");

        const refVariantId = btn.data("ref-variant-id");
        const eticketId = btn.data("eticket-id");
        const cakeVariantId = cartData.anniversaryCakeVariantId;

        try {
          await CartAPI.addItems([
            { id: refVariantId, quantity: 1, properties: { _eticket: eticketId } },
            { id: cakeVariantId, quantity: 1, properties: { _eticket_pair: eticketId } },
          ]);
          window.location.href = "/cart";
        } catch (error) {
          console.error("Anniversary e-ticket add failed:", error);
          window.location.href = `/cart/add?id=${refVariantId}&quantity=1&properties[_eticket]=${eticketId}`;
        }
      });
    }

    $(".js-anniversary-eticket-remove").on("click", async function (event) {
      event.preventDefault();
      const btn = $(this);
      btn.css("pointer-events", "none");

      const eticketItemKey = btn.data("eticket-item-key");
      const eticketId = String(btn.data("eticket-id"));

      try {
        const cart = await CartAPI.getCart();
        const pairItem = cart.items.find((item) =>
          item.properties && String(item.properties._eticket_pair) === eticketId
        );
        const updates = { [eticketItemKey]: 0 };

        if (pairItem) {
          updates[pairItem.key] = 0;
        }

        await CartAPI.updateCart(updates);
        window.location.reload();
      } catch (error) {
        console.error("Anniversary e-ticket remove failed:", error);
        window.location.href = `/cart/change?id=${encodeURIComponent(eticketItemKey)}&quantity=0`;
      }
    });
  };

  // init関数の例外が他のinitやページ全体を道連れにしないよう、1つずつ隔離して実行する。
  const safeInit = (initFn) => {
    try {
      initFn();
    } catch (error) {
      console.error(`Cart page init failed: ${initFn.name}`, error);
    }
  };

  // 初期自動修正で reload/redirect する場合は、古いDOMに対してイベントを張らない。
  runInitialCartCorrections()
    .then((correctedCart) => {
      if (correctedCart) {
        return;
      }

      // 初期化順序:
      // 1. checkout判定に関わるアイス/配送UI
      // 2. eギフト表示とスライダー
      // 3. カート更新を伴うギフトバッグ/周年eチケット
      // 4. 入力フォーム補助
      [
        initIceControls,
        initDeliveryDatePicker,
        initEgiftLimitDate,
        initEgiftSlider,
        initGiftBagOptions,
        initSenderName,
        initEgiftForm,
        initAnniversaryEticket,
      ].forEach(safeInit);
    })
    .catch((error) => {
      // ここに到達するのは runInitialCartCorrections の想定外の例外のみ。
      // リロードすると同じ例外を繰り返して無限ループになるため、ログに留める。
      console.error("Cart page initialization failed:", error);
    });
});
